import {useContext, useEffect} from "react";
import {AuthContext} from "./AuthContext";
import {useHistory} from "react-router";
import service from "../api/encoding/api";
import getHomePageUrl from './HomePageUrl';


export default function CheckAuth(){

    const authContext = useContext(AuthContext);
    const history = useHistory();

    async function checkAuthenticated() {
        console.log("calling app for auth")
        const result = await service.get("/v1/auth/me")
        .catch( async error =>{
            history.replace("/")
        });
        

        if(result?.status){
            console.log(result)
           const role = result?.data?.role;
           const businessId = result?.data?.businessIdDescription;
           const email= result?.data?.userEmail;
           await authContext.login(role,businessId,email);
           const homePageUrl = getHomePageUrl(role);
           history.replace(homePageUrl);
        }
    }
   
    useEffect(() =>{
        checkAuthenticated();
    },[])

    return <div></div>

}